import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./header.scss";

const UserAssistance = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (
      localStorage.getItem("logged_user") === null ||
      localStorage.getItem("logged_user") === JSON.stringify(false)
    ) {
      localStorage.setItem("logged_out_from", "userassistance /");
      navigate("/");
    }
    window.addEventListener("storage", (e: any) => {
      if (e && e.key == "logged_user") {
        window.close();
      }
    });
  }, []);
  console.log("User Assistance Loaded", window.location.href);

  return (
    <div className="userAssistance-wrapper">
      <iframe
        title="User Assistance"
        // src="/userAssistance/Content/Resources/Station%20Help%20Landing%20pages/Home.htm"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  );
};

export default UserAssistance;
